import { Card as CardAntd } from 'antd';
import styled from 'styled-components';

export const Card = styled(CardAntd)`
  .ant-card-body {
    padding-top: 0;
  }

  .height-85 {
    height: 85vh;
  }

  .margin-sides {
    margin: 0 8px;
  }
`;
